import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
// @mui
import { Box, Card, CardHeader } from "@mui/material";
// components
import { useChart } from "../../../components/chart";

// ----------------------------------------------------------------------

SubscibedChart.propTypes = {
  chartData: PropTypes.object,
  duration: PropTypes.string,
};

export default function SubscibedChart({ chartData, duration }) {
  const chartLabels = [
    "Premium Users",
    "Free Users",
    "Device + Premium Users",
    "Device Users",
  ];

  const chartSeries = useMemo(() => {
    return [
      Number(chartData?.premiumUsers) || 0,
      Number(chartData?.freeUsers) || 0,
      Number(chartData?.devicePremiumUsers) || 0,
      Number(chartData?.deviceUsers) || 0,
    ];
  }, [chartData]);

  const chartOptions = useChart({
    chart: {
      type: "donut",
    },
    labels: chartLabels,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
          },
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "11px",
            itemMargin: { horizontal: 8, vertical: 4 },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "12px",
            itemMargin: { horizontal: 10, vertical: 4 },
          },
        },
      },
    ],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              formatter: (val) => {
                if (
                  val &&
                  typeof val === "string" &&
                  val.split(" ")[0] === "Total"
                ) {
                  return val.split(" ")[0];
                }
                return `${val || ""}`;
              },
            },
          },
          size: "75%",
        },
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "left",
      fontSize: "13px",
      itemMargin: { horizontal: 12, vertical: 4 },
    },
  });

  return (
    <Card sx={{ height: { xs: "500px", md: "480px" } }}>
      <CardHeader title="User Types" />
      <Box sx={{ mx: 3 }} dir="ltr">
        <ReactApexChart
          type="donut"
          series={chartSeries}
          options={chartOptions}
          height={350}
        />
      </Box>
    </Card>
  );
}